import type { Dialect } from '@/providers/LearnerPreferences';
import { MODE_LABELS } from '@/lib/modes';
import { typeScale } from '@/lib/typography';

const ITALIC_FACE = { fontSynthesis: 'style' } as const;

export function ModeWordmark({
  dialect,
  variant = 'title',
  className = '',
}: {
  dialect: Dialect;
  variant?: 'title' | 'option';
  className?: string;
}) {
  const isMoob = dialect === 'moob';
  if (variant === 'title') {
    return (
      <span
        data-testid="mode-wordmark"
        data-mode-wordmark={dialect}
        className={`whitespace-nowrap ${typeScale.hubTitle} ${isMoob ? 'italic' : 'not-italic'} ${className}`}
        style={isMoob ? ITALIC_FACE : undefined}
      >
        {isMoob ? (
          MODE_LABELS.moob
        ) : (
          <>
            Hmong
            <span className="italic font-black" style={ITALIC_FACE}>
              lus
            </span>
          </>
        )}
      </span>
    );
  }

  return (
    <span
      data-testid="mode-wordmark-option"
      className={`whitespace-nowrap font-nunito text-xl font-bold text-[#1E1E1E] ${
        isMoob ? 'italic' : 'not-italic'
      } ${className}`}
      style={isMoob ? ITALIC_FACE : undefined}
    >
      {isMoob ? (
        MODE_LABELS.moob
      ) : (
        <>
          Hmong<span className="font-extrabold">lus</span>
        </>
      )}
    </span>
  );
}
